import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-samband',
  templateUrl: './samband.component.html',
  styleUrls: ['./samband.component.css']
})
export class SambandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
